import { render, staticRenderFns } from "./UserMaintain.vue?vue&type=template&id=40753f54&scoped=true&"
import script from "./UserMaintain.vue?vue&type=script&lang=js&"
export * from "./UserMaintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40753f54",
  null
  
)

export default component.exports